import { and } from '@ember/object/computed';
import Em from 'ember';
const INITIAL_VISIBLE_ITEM_COUNT = 3;
export default Em.Component.extend({
  isCollapsed: true,
  needsExpander: true,
  canExpand: Em.computed('list.length', function () {
    return this.get('list.length') > INITIAL_VISIBLE_ITEM_COUNT;
  }),
  showExpander: and('canExpand', 'isCollapsed', 'needsExpander'),
  listToShow: Em.computed('isCollapsed', function () {
    if (this.get('isCollapsed')) {
      return this.get('list').slice(0, INITIAL_VISIBLE_ITEM_COUNT);
    }
    return this.get('list');
  }),
  actions: {
    handleItemSelected(item) {
      this.itemSelected(item);
    },
    expandList() {
      this.set('isCollapsed', false);
    }
  }
});